export enum DataLoadState {
    None,
    Loading,
    Loaded,
    Error
}

export interface IEnumLoadableState {
    loadState: DataLoadState
}